import React, { useState } from 'react';
import styles from './TemplatePreviewWhatsApp.module.css';
import { FaWhatsapp, FaMoon, FaSun } from "react-icons/fa";

const TemplatePreviewWhatsApp = ({ headerData, previewText }) => {
    const [darkMode, setDarkMode] = useState(false);
    const currentTime = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    return (
        <div className={`${styles.deviceWrapper} ${darkMode ? styles.dark : ''}`}>
            <div className={styles.deviceHeader}>
                <div className={styles.headerLeft}>
                    <FaWhatsapp className={styles.whatsappIcon} />
                    <span>WhatsApp Preview</span>
                </div>
                <button onClick={() => setDarkMode(!darkMode)} className={styles.modeToggle}>
                    {darkMode ? <FaSun /> : <FaMoon />}
                </button>
            </div>

            <div className={styles.receiverBar}>
                <img
                    src="https://stylelink.s3.ap-south-1.amazonaws.com/LokaciPro/lokaci-pro-logo.png"
                    alt="Profile"
                    className={styles.profilePic}
                />
                <div className={styles.receiverInfo}>
                    <div className={styles.receiverName}>Lokaci Pro</div>
                    <div className={styles.receiverStatus}>Business Account</div>
                </div>
            </div>

            <div className={styles.chatScreen}>
                <div className={styles.messageBubble}>
                    {headerData?.headerType==='text' && <p>{headerData?.headerContent}</p>}
                    {headerData?.headerType==='image' && <img className={styles.messageImg} src={headerData?.headerContent}/>}
                    <p className={styles.messageText}>{previewText}</p>
                    <span className={styles.timestamp}>{currentTime}</span>
                </div>
            </div>
        </div>
    )
};

export default TemplatePreviewWhatsApp;
